
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationCarteiraPedido } from '../integration-carteira-pedido';

@Injectable({
    providedIn: 'root'
})
export class IntegrationCarteiraPedidoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/carteirapedido`;
    }

    /** Executa a integração de leitura da carteira de pedidos com os sistemas ERP's */
    execReadIntegration(entity: IntegrationCarteiraPedido): Observable<string> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }

    /** Executa a integração de leitura individual dos dados da carteira de pedido informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
